/**
 * Single-Select-Verhalten fuer ShopPad-Checkbox-Pflichtfelder. v3
 *
 * ShopPad rendert "Radio Button"-Optionen mit Pflichtfeld als
 * <input type="checkbox"> in einem <fieldset data-required="true">.
 * Default-Verhalten: User muss alte Auswahl manuell abwaehlen, bevor
 * neue greifen kann. Wir erzwingen Radio-Verhalten clientseitig.
 *
 * v3: Capture-Phase click-Handler, der SYNCHRON vor dem Browser-Toggle
 * alle anderen Checkboxen im Fieldset abwaehlt. Default-Toggle der
 * geklickten Checkbox laeuft danach normal weiter. Zusaetzlich ein
 * change-Fallback, falls der Klick auf das Input direkt geht (z.B. mobile).
 */
(function () {
  'use strict';

  function uncheckOthers(targetCb) {
    const fieldset = targetCb.closest('fieldset[data-required]');
    if (!fieldset) return;
    fieldset.querySelectorAll('input[type="checkbox"]').forEach(function (other) {
      if (other === targetCb || !other.checked) return;
      other.checked = false;
      other.dispatchEvent(new Event('change', { bubbles: true }));
      other.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  // Capture-phase click: laeuft VOR dem Browser-Default-Toggle.
  // Wir wissen: wenn auf ein <label> in einem fieldset[data-required] geklickt
  // wird, wird gleich die zugehoerige Checkbox getoggelt. Wenn sie aktuell
  // unchecked ist, wird sie checked -> alle anderen muessen unchecked werden.
  document.addEventListener(
    'click',
    function (e) {
      const lbl = e.target.closest && e.target.closest('fieldset[data-required] label');
      if (!lbl) return;
      const cb = lbl.querySelector('input[type="checkbox"]');
      if (!cb) return;
      // Nur reagieren wenn die geklickte gerade unchecked ist (wird gleich checked)
      if (cb.checked) return;
      uncheckOthers(cb);
    },
    true // capture
  );

  // Fallback fuer den Fall, dass ein change-Event ohne vorigen click kommt
  // (z.B. JS-triggered oder keyboard-toggle)
  document.addEventListener(
    'change',
    function (e) {
      const cb = e.target;
      if (!cb || cb.tagName !== 'INPUT' || cb.type !== 'checkbox') return;
      if (!cb.checked) return;
      if (!cb.closest('fieldset[data-required]')) return;
      uncheckOthers(cb);
    },
    true
  );
})();
